import { fetchManager } from '../utils/fetchManager';

export const companyService = {
  loadCompanyList: () => fetchManager('get', 'companies'),

  loadMyCompanyList: () => fetchManager('get', 'my-companies'),

  loadCompany: companyId => fetchManager('get', `companies/${companyId}`),

  loadCompanyAnalytics: companyId => fetchManager('get', `companies/${companyId}/analytics-data`),

  updateCompany: (companyId, company) => fetchManager('put', `companies/${companyId}`, company),

  enableCompany: companyId => fetchManager('put', `companies/${companyId}/enable`),

  disableCompany: companyId => fetchManager('put', `companies/${companyId}/disable`),

  exportCompanyAnalytics: (companyId, action) => fetchManager('get', `companies/${companyId}/export-analytics${action}`),

  exportCompanies: () => fetchManager('get', `companies-export`),
};
